import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorToast from '@/components/toasts/ErrorToast';
import { responseError } from '@/utils/errors';
import showToast from '@/utils/toasts';
import actions from '../constants';

export function* updateToast({ result }) {
  yield call(showToast, <UpdatedToast code={result.code} name={result.name} />);
}

export function* chooseThemeErrorToast(action) {
  yield call(
    showToast,
    <ErrorToast operation="actions.select" name={action.name} error={responseError(action).message} />,
  );
}

export function* enableThemeErrorToast(action) {
  yield call(
    showToast,
    <ErrorToast operation="actions.update" name={action.name} error={responseError(action).message} />,
  );
}

export default function* themesToasts() {
  yield takeEvery(actions.CHOOSE_THEME_ERROR, chooseThemeErrorToast);
  yield takeEvery([actions.EDIT_THEME, actions.EDIT_THEME_ENABLED], updateToast);
  yield takeEvery(actions.EDIT_THEME_ENABLED_ERROR, enableThemeErrorToast);
}
